import { render, staticRenderFns } from "./DocketBook.vue?vue&type=template&id=20e79b33&"
import script from "./DocketBook.vue?vue&type=script&lang=js&"
export * from "./DocketBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports